import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faMapLocationDot } from '@fortawesome/free-solid-svg-icons'
import { localityName, formatTime, passengerCount } from './tripUtils'

const UpcomingPanel = ({ trips = [], open, setOpen, showOnMap, setShowOnMap, onOpenTrip }) => {
  return (
    <div className='shrink-0 rounded-2xl border overflow-hidden' style={{ background: 'var(--panel)', borderColor: 'var(--border)', boxShadow: 'var(--shadow-card)' }}>
      <div className='flex items-center gap-2.5 px-3.5 py-3'>
        <button onClick={() => setOpen(o => !o)} className='flex items-center gap-2.5 flex-1 min-w-0 text-left'>
          <FontAwesomeIcon
            icon={faChevronDown}
            className='text-xs transition-transform duration-200'
            style={{ color: 'var(--text-soft)', transform: open ? 'rotate(0deg)' : 'rotate(-90deg)' }}
          />
          <span className='font-bold text-[14px] truncate' style={{ color: 'var(--text)' }}>Próximos a salir</span>
          <span className='flex items-center justify-center min-w-[24px] h-6 px-2 text-xs font-bold tabular-nums rounded-full' style={{ background: 'var(--amber-soft)', color: 'var(--amber)' }}>
            {trips.length}
          </span>
        </button>
        {/* Toggle: mostrar en el mapa */}
        <button
          onClick={() => setShowOnMap(s => !s)}
          title='Mostrar en el mapa'
          className='flex items-center gap-1.5 h-7 px-2.5 rounded-full text-[11px] font-semibold transition-colors'
          style={
            showOnMap
              ? { background: 'var(--coral)', color: '#fff' }
              : { background: 'var(--panel-soft)', color: 'var(--text-soft)', border: '1px solid var(--border)' }
          }
        >
          <FontAwesomeIcon icon={faMapLocationDot} className='text-[11px]' />
          <span className='hidden sm:inline'>En mapa</span>
        </button>
      </div>

      {open && (
        <div className='live-scroll max-h-[34vh] overflow-y-auto px-2 pb-2'>
          {trips.length === 0 ? (
            <div className='text-center text-sm py-4' style={{ color: 'var(--text-faint)' }}>No hay próximos viajes con pasajeros.</div>
          ) : (
            trips.map(t => (
              <button
                key={t._id}
                onClick={() => onOpenTrip && onOpenTrip(t._id)}
                className='w-full flex items-center gap-2.5 rounded-xl px-2.5 py-2 text-left transition-colors hover:opacity-90'
                style={{ background: 'transparent' }}
              >
                <span className='tabular-nums text-xs font-semibold shrink-0' style={{ color: 'var(--coral)' }}>
                  {formatTime(t?.Journey?.departure_time)}
                </span>
                <span className='w-1.5 h-1.5 rounded-full shrink-0' style={{ background: 'var(--amber)' }} />
                <span className='text-[13px] truncate flex-1' style={{ color: 'var(--text)' }}>
                  {localityName(t?.Journey?.origin_name)} <span style={{ color: 'var(--text-faint)' }}>→</span> {localityName(t?.Journey?.destination_name)}
                </span>
                <span className='text-[11px] font-semibold shrink-0' style={{ color: 'var(--text-soft)' }}>{passengerCount(t)}p</span>
              </button>
            ))
          )}
        </div>
      )}
    </div>
  )
}

export default UpcomingPanel
